import React from 'react'
import Modals from '../Modals/Modals'
import SecBTN from '../SecBTN'
import classes from './ConfirmationModal.module.css'

const ConfirmationModal = ({ title, show, onHide, yesHandler, noHandler, confirmTxt, type, onSubmit, ...rest }) => {
  return (
    <Modals
      className={classes.modal}
      show={show}
      onHide={onHide}
      {...rest}
    >
      <h6>{title}</h6>
      <div className={classes["confirmation-sec"]}>
        <SecBTN className={classes["no-btn"]} onClick={noHandler}>
          No
        </SecBTN>
        <SecBTN type={type ? type : "button"} className={classes["yes-btn"]} onClick={yesHandler}>
          {confirmTxt}
        </SecBTN>
      </div>
    </Modals>
  )
}

export default ConfirmationModal
